module.exports = __webpack_public_path__ + "prod/1.42.2/img/qr-code.01bc4971.png";